export default __webpack_public_path__ + "static/media/ai_governance_gaps_open.df7fb537.svg";